import { useState, useEffect } from 'react'

const STORAGE_KEY = 'boothly_favorites'
const SYNC_EVENT = 'boothly-favorites-changed'

function readFavs() {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [] }
  catch { return [] }
}

export function useFavorites() {
  const [favIds, setFavIds] = useState(readFavs)

  useEffect(() => {
    const handler = () => setFavIds(readFavs())
    window.addEventListener(SYNC_EVENT, handler)
    return () => window.removeEventListener(SYNC_EVENT, handler)
  }, [])

  const toggle = (storeId) => {
    const prev = readFavs()
    const next = prev.includes(storeId)
      ? prev.filter(id => id !== storeId)
      : [...prev, storeId]
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
    setFavIds(next)
    window.dispatchEvent(new Event(SYNC_EVENT))
  }

  const isFav = (storeId) => favIds.includes(storeId)

  return { favIds, toggle, isFav }
}
